import { isValid } from "@workflows/std-js/datetime";
import { format, formatDistance } from "date-fns";
import { locales } from "~/core/i18n";
export function getFormattedDistance(date: string | Date, currentLocale = "en") {
  const input = isValid(date) ? date : new Date(date);
  return formatDistance(input, new Date(), {
    locale: locales[currentLocale],
    addSuffix: true
  });
}
export function getFormattedDay(dueDate: string, currentLocale = "en") {
  return format(new Date(dueDate), "dd.MM.yyyy", {
    locale: locales[currentLocale]
  });
}